export const articles = [
  {
    id: '1',
    title: '某顶流男星深夜私会神秘女子，酒店共度三小时被拍',
    slug: 'top-male-star-hotel-mystery-woman',
    excerpt: '据知情人士透露，某一线男星于昨日深夜被拍到与一神秘女子共同进入某五星级大酒店，两人在酒店内共度约三小时后分别离开。该男星此前一直以单身人设示人...',
    category: '娱乐八卦',
    categorySlug: 'entertainment',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20paparazzi-style%20night%20photography%20of%20luxury%20hotel%20entrance%20with%20blurred%20figures%2C%20neon%20city%20lights%2C%20mysterious%20atmosphere%2C%20warm%20amber%20tones%2C%20cinematic%20composition%2C%20shallow%20depth%20of%20field%2C%20editorial%20journalism%20style&width=800&height=500&seq=article-01&orientation=landscape',
    author: '爆料小能手',
    date: '2026-07-02',
    views: 45823,
    isHot: true,
    isVideo: false,
    tags: ['明星', '绯闻', '酒店'],
  },
  {
    id: '2',
    title: '知名女演员被曝片场耍大牌，工作人员集体吐槽',
    slug: 'actress-diva-behavior-set',
    excerpt: '多位剧组工作人员在社交平台匿名爆料，某热播剧女主角在片场频频耍大牌，要求单独休息室、指定品牌矿泉水，甚至因道具不满意当场发飙...',
    category: '明星黑料',
    categorySlug: 'celebrity',
    image: 'https://readdy.ai/api/search-image?query=Behind-the-scenes%20film%20set%20photography%20with%20dramatic%20studio%20lighting%2C%20camera%20equipment%20in%20foreground%2C%20professional%20production%20environment%2C%20warm%20tungsten%20lights%2C%20cinematic%20grain%2C%20editorial%20documentary%20style&width=800&height=500&seq=article-02&orientation=landscape',
    author: '娱乐圈侦探',
    date: '2026-07-02',
    views: 32156,
    isHot: true,
    isVideo: true,
    videoDuration: '03:24',
    tags: ['演员', '耍大牌', '剧组'],
  },
  {
    id: '3',
    title: '某选秀节目冠军被扒学历造假，人设彻底崩塌',
    slug: 'talent-show-champion-fake-degree',
    excerpt: '有网友深挖某选秀节目冠军的个人资料，发现其声称的海外名校学历存在严重造假嫌疑。多所院校官方表示查无此人，其精心打造的学霸人设面临全面崩塌...',
    category: '社会热点',
    categorySlug: 'social',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20breaking%20glass%20effect%20with%20shattered%20mirror%20pieces%20reflecting%20warm%20golden%20light%2C%20dramatic%20texture%20close-up%2C%20symbolic%20destruction%20of%20illusion%2C%20artistic%20editorial%20photography%2C%20high%20contrast%2C%20warm%20tones&width=800&height=500&seq=article-03&orientation=landscape',
    author: '真相追击者',
    date: '2026-07-01',
    views: 28934,
    isHot: true,
    isVideo: false,
    tags: ['选秀', '学历造假', '人设崩塌'],
  },
  {
    id: '4',
    title: '千万粉丝网红直播中泄露隐私，引发全网热议',
    slug: 'influencer-livestream-privacy-leak',
    excerpt: '一位拥有千万粉丝的头部网红在昨日直播中因操作失误，意外暴露了个人敏感信息。直播画面被大量截图传播，相关话题迅速登上热搜榜...',
    category: '网红资讯',
    categorySlug: 'internet',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20screen%20showing%20live%20streaming%20interface%20with%20glowing%20neon%20accents%2C%20dark%20background%2C%20warm%20amber%20and%20orange%20light%20reflections%2C%20tech%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20sleek%20minimal%20composition&width=800&height=500&seq=article-04&orientation=landscape',
    author: '网红观察员',
    date: '2026-07-01',
    views: 67892,
    isHot: true,
    isVideo: true,
    videoDuration: '05:17',
    tags: ['网红', '直播', '隐私泄露'],
  },
  {
    id: '5',
    title: '某知名导演被曝潜规则多名女演员，录音证据流出',
    slug: 'director-casting-couch-recording',
    excerpt: '一段据称是某知名导演与女演员的对话录音近日在网络曝光，内容涉及不当交易。多位匿名女演员随后发声，称自己也曾遭遇类似情况...',
    category: '丑闻曝光',
    categorySlug: 'scandal',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20film%20director%20chair%20silhouette%20in%20smoky%20studio%20environment%2C%20dramatic%20backlighting%20with%20warm%20amber%20glow%2C%20cinematic%20atmosphere%2C%20mysterious%20shadows%2C%20editorial%20photography%20style%2C%20high%20contrast&width=800&height=500&seq=article-05&orientation=landscape',
    author: '正义之声',
    date: '2026-06-30',
    views: 89234,
    isHot: true,
    isVideo: true,
    videoDuration: '08:42',
    tags: ['导演', '潜规则', '录音'],
  },
  {
    id: '6',
    title: '独家：某流量小生与资本方闹翻，或将面临天价违约金',
    slug: 'exclusive-idol-capital-fallout',
    excerpt: '据内部人士独家爆料，某当红流量小生因不满经纪公司安排，近期与资本方产生严重分歧。双方谈判陷入僵局，该艺人或将面临高达数千万的违约赔偿...',
    category: '独家爆料',
    categorySlug: 'exclusive',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20financial%20documents%20and%20contract%20papers%20scattered%20dramatically%20on%20dark%20wooden%20desk%2C%20warm%20golden%20light%20from%20above%2C%20cinematic%20composition%2C%20business%20conflict%20theme%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=article-06&orientation=landscape',
    author: '圈内人',
    date: '2026-06-30',
    views: 56721,
    isHot: false,
    isVideo: false,
    tags: ['流量小生', '违约金', '资本'],
  },
  {
    id: '7',
    title: '某女团成员退团内幕曝光，与公司存在严重合同纠纷',
    slug: 'girl-group-member-contract-dispute',
    excerpt: '日前宣布退团的女团成员真实原因曝光，并非官方宣称的个人发展，而是因与公司存在严重的合同分歧。成员家属已委托律师介入...',
    category: '娱乐八卦',
    categorySlug: 'entertainment',
    image: 'https://readdy.ai/api/search-image?query=Empty%20stage%20with%20single%20spotlight%20illuminating%20microphone%20stand%2C%20dark%20concert%20venue%20background%2C%20warm%20amber%20stage%20lighting%2C%20lonely%20atmosphere%2C%20performance%20absence%20theme%2C%20editorial%20photography%20style&width=800&height=500&seq=article-07&orientation=landscape',
    author: '韩娱追踪',
    date: '2026-06-29',
    views: 42345,
    isHot: false,
    isVideo: true,
    videoDuration: '04:33',
    tags: ['女团', '退团', '合同纠纷'],
  },
  {
    id: '8',
    title: '某男星被曝隐婚生子，妻子竟是圈外素人',
    slug: 'male-star-secret-marriage-child',
    excerpt: '一直以单身形象示人的某男星被拍到与一女子及儿童共同出入住所，疑似早已隐婚生子。经调查，该女子为圈外素人，两人相识多年...',
    category: '明星黑料',
    categorySlug: 'celebrity',
    image: 'https://readdy.ai/api/search-image?query=Suburban%20family%20home%20exterior%20at%20golden%20hour%2C%20warm%20sunset%20lighting%2C%20cozy%20residential%20atmosphere%2C%20slightly%20blurred%20figures%20in%20windows%2C%20privacy%20and%20secrecy%20theme%2C%20editorial%20lifestyle%20photography%2C%20warm%20earth%20tones&width=800&height=500&seq=article-08&orientation=landscape',
    author: '娱记老王',
    date: '2026-06-29',
    views: 76543,
    isHot: true,
    isVideo: false,
    tags: ['隐婚', '生子', '圈外'],
  },
  {
    id: '9',
    title: '网红主播偷税漏税被查，补税金额高达八位数',
    slug: 'streamer-tax-evasion-investigation',
    excerpt: '税务部门通报某头部带货主播存在严重偷税漏税行为，经查实其通过设立多家空壳公司转移收入，逃避税款金额高达数千万元...',
    category: '社会热点',
    categorySlug: 'social',
    image: 'https://readdy.ai/api/search-image?query=Government%20official%20document%20with%20red%20stamp%20on%20dark%20wood%20surface%2C%20warm%20dramatic%20lighting%20from%20side%2C%20official%20seal%20and%20stamp%20impression%2C%20authority%20and%20investigation%20theme%2C%20editorial%20documentary%20photography%2C%20high%20contrast&width=800&height=500&seq=article-09&orientation=landscape',
    author: '财经观察',
    date: '2026-06-28',
    views: 54321,
    isHot: true,
    isVideo: true,
    videoDuration: '06:18',
    tags: ['主播', '偷税', '被查'],
  },
];